import React from 'react'
import { connect } from 'react-redux'
import UtilitiesMenu from './UtilitiesMenu'

const Utilities = props => {
  return (
    <div style={styles.container} >
      <div style={styles.header}>
        <UtilitiesMenu />
      </div>
      {/* export - could be moved in a separate component, but since this is the only sub-item in utilities, we could directly put export here for the meantime */}
    </div>
  )
}

const mapStateToProps = state => {
  return{}
}
export default connect(mapStateToProps)(Utilities)

const styles = {
  container: {
    width: '75vw',
    padding: '2vmin',
    border: '2px solid gray',
    borderRadius: 5,
    backgroundColor: 'rgba(10, 14, 25, 0.6)',
    color: 'white',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1vmin',
    margin: '0 1%',
  },
}